import Todo from '../../../components/Todo'
import { Page } from '../../types'

type TricksORToolsProps = { }
const render = () => {
    return <>
    <h3>Exporting a model</h3>
    <p>
        ORTools only supports exporting the model to a string. You need to manually
        write that string to a file. For example, to create an MPS file, use;
<pre>
with open("filename.mps", "w") as out_f:<br/>
&nbsp;&nbsp;str = solver.ExportModelAsMpsFormat(fixed_format=False, obfuscated=False)<br/>
&nbsp;&nbsp;out_f.write(str)
</pre>
    </p>
    <h3>Customizing the Gurobi environment</h3>
    <p>
        You can't influence how OR-Tools creates the underlying Gurobi environment. To use settings
        for Web License Service, Compute Server, Token Server or Instant Cloud you will need to 
        have a license file that contains the settings; Gurobi will read this file when setting up
        your environment through OR-Tools.
    </p>
    <h3>Setting model parameters</h3>
    <p>
        To set Gurobi parameters, you need to describe them in a string with a very
        specific format. Each parameter goes on a single line, with the name and value separated
        by a space. For example:
        <pre>
        solver.SetSolverSpecificParametersAsString("Threads 1\nHeuristics 0.1")
        </pre>
    </p>    
    <h3>Showing Gurobi log output</h3>
    <p>
        To view Gurobi log output when solving your model, call <code>solver.EnableOutput()</code>.
        To also write the log file to disk, use the trick above to set <code>OutputFlag</code> and <code>LogFile</code> parameters:
        <pre>settings = "OutputFlag 1 \n LogFile gurobi.log"<br/>solver.SetSolverSpecificParametersAsString(settings);</pre>
    </p>
    <Todo>
        <h3>Disposing your environment</h3>
        <p>
            It is not clear whether there is a need to explicitly dispose your environment and release any
            WLS or Token Server tokens and how to do that with Google OR-tools.
        </p>
    </Todo>    
    </>
}

const TricksORTools : Page<TricksORToolsProps> = { title: 'Tips and tricks for ORTools', key: 'tricks-ortools', render }

export default TricksORTools